import { TranslateFunction } from 'react-utilities';
import { ErrorCode } from '../interface';

// IMPORTANT: Add resource keys to `app.config.ts` as well.
export const getResources = (translate: TranslateFunction) =>
  ({
    Action: {
      PleaseTryAgain: translate('Action.PleaseTryAgain'),
      Reload: translate('Action.Reload')
    },
    Header: {
      RobotChallenge: translate('Header.RobotChallenge')
    },
    Message: {
      Error: {
        Default: translate('Message.Error.Default')
      }
    }
  } as const);

export type CaptchaResources = ReturnType<typeof getResources>;

export const mapChallengeErrorCodeToResource = (
  resources: CaptchaResources,
  errorCode: ErrorCode
): string => {
  switch (errorCode) {
    default:
      return resources.Message.Error.Default;
  }
};
